module.exports = __webpack_public_path__ + "img/shopping-bag.fbc1c126.svg";